import api from './api';

const hrService = {
  getEmployees:          (token)         => api.get('/hr/employees', token),
  getEmployee:           (id, token)     => api.get(`/hr/employees/${id}`, token),
  createEmployee:        (data, token)   => api.post('/hr/employees', data, token),
  updateEmployee:        (id, data, token) => api.put(`/hr/employees/${id}`, data, token),
  getAttendance:         (token)         => api.get('/hr/attendance', token),
  markAttendance:        (data, token)   => api.post('/hr/attendance', data, token),
  getLeaveRequests:      (token)         => api.get('/hr/leave', token),
  createLeaveRequest:    (data, token)   => api.post('/hr/leave', data, token),
  updateLeaveRequest:    (id, data, token) => api.put(`/hr/leave/${id}`, data, token),
  getPayroll:            (token)         => api.get('/hr/payroll', token),
  getRecruitment:        (token)         => api.get('/hr/recruitment', token),
  createRecruitment:     (data, token)   => api.post('/hr/recruitment', data, token),
  getPerformance:        (token)         => api.get('/hr/performance', token),
  getTraining:           (token)         => api.get('/hr/training', token),
  createTraining:        (data, token)   => api.post('/hr/training', data, token),
  getDisciplinary:       (token)         => api.get('/hr/disciplinary', token),
  createDisciplinary:    (data, token)   => api.post('/hr/disciplinary', data, token),
  getHRAssets:           (token)         => api.get('/hr/assets', token),
  createHRAsset:         (data, token)   => api.post('/hr/assets', data, token),
  getExits:              (token)         => api.get('/hr/exits', token),
  createExit:            (data, token)   => api.post('/hr/exits', data, token),
};

export default hrService;
